const configuration = {
  API_ROOT: 'https://swapi.co/api',
  MAX_RETRIES: 5,
  MIN_ID: 1,
  MAX_ID: 37
};

export default configuration;
